import { appendQueryParam } from './appendQueryParam';
export function appendLoginHint(url, loginHint, loginHintEnabled) {
    if (loginHintEnabled) {
        return appendQueryParam(url, 'login_hint', loginHint);
    }
    return url;
}
//# sourceMappingURL=appendLoginHint.js.map